import { useEffect, useState } from 'react'
import userManager from '../../oidcConfig'
import { useNavigate } from 'react-router-dom'
import { oidcLogin } from '../../services/api'
import { setUserSession } from '../../utils/sessionManagement'
import LoadingPage from '../../components/Loading/LoadingPage'

import styles from './CallbackPage.module.css'

import Header from '../../components/Header/Header'
import { Link } from 'react-router-dom'

const CallbackPage = () => {
  const history = useNavigate()
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    userManager
      .signinRedirectCallback()
      .then((user) => {
        // Connexion automatique au backend après l'authentification SSO réussie
        oidcLogin(user.access_token)
          .then(({ data }) => {
            const {
              key,
              id,
              username,
              first_name,
              last_name,
              is_admin,
              email,
              is_external,
            } = data
            setUserSession(
              key,
              id,
              username,
              first_name,
              last_name,
              is_admin,
              email,
              is_external
            )
            setLoading(false)

            const redirectPath =
              localStorage.getItem('redirectPath') || '/workspaces'
            history(redirectPath)
            localStorage.removeItem('redirectPath')
          })
          .catch((error) => {
            setLoading(false)
            setError(
              error.response
                ? error.response.data.message
                : 'Something went wrong. Please try again later.'
            )
          })
      })
      .catch((error) => {
        setLoading(false)
        console.error('Erreur lors de la connexion :', error)
        setError(error.toString())
      })
  }, [history])

  return (
    <div>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className={styles.page}>
          <Header isAnswersResponse={false} />

          <div className={styles.bloc}>
            <div className={styles.text_bloc}>
              <div className={styles.headline}>
                Whoops, cette page n'est pas disponible.
              </div>
              <div className={styles.headline_subtitle}>
                {error && <div>Erreur : {error}</div>}
              </div>
              <div className={styles.headline}>
                <Link to={'/workspaces'}>
                  <button className={styles.createButton}>
                    Retour à l'accueil
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CallbackPage
